import { render, staticRenderFns } from "./BannerActivateBilling.vue?vue&type=template&id=3bc62750&scoped=true&"
import script from "./BannerActivateBilling.vue?vue&type=script&lang=ts&"
export * from "./BannerActivateBilling.vue?vue&type=script&lang=ts&"
import style0 from "./BannerActivateBilling.vue?vue&type=style&index=0&id=3bc62750&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc62750",
  null
  
)

export default component.exports